<h1 mat-dialog-title>{{ data.title | translate }}</h1>
<mat-dialog-content>
  {{ data.message | translate }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" cdkFocusInitial>{{ 'DIALOGS.OK' | translate }}</button>
</mat-dialog-actions>
